import React, { useEffect, useState } from "react";
import "./styles.css";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, Pagination, PaginationItem } from "@mui/material";
import { postData } from "../../Hooks/apiCalls";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../CommonComponents/Loader";
import DSApprovedModal from "./DSApprovedModal";
import { isDevelopment } from "../../Hooks/constants";
import YesNoModal from "./YesNoModal";
import FileModal from "./FileModal";
import DSBillDetailsModal from "./DSBillDetailsModal";

const DSRefundHomepage = ({
  handleOpenCreateRequest,
  getAllRefundDetailsApi = () => {},
  allRefundData,
  allRefundDetailsLoader,
}) => {
  // variables
  const domain_id = Cookies.get("ssp_domain_id");
  const ssp_role = Cookies.get("ssp_role");

  // states
  const [approveHistoryLoader, setapproveHistoryLoader] = useState(false);
  const [downloadingLoader, setDownloadingLoader] = useState(false);
  const [approveRequestLoader, setApproveRequestLoader] = useState(false);

  const [selectedRequestIds, setSelectedRequestIds] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1); // 1-based for MUI Pagination
  const [pageSize, setPageSize] = useState(10);
  const [openApprovedModal, setOpenApprovedModal] = useState(false);
  const [approvedData, setApprovedData] = useState([]);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [previewDoc, setPreviewDoc] = useState(false);
  const [previewDocData, setpreviewDocData] = useState({
    url: "",
    type: "image/png",
  });
  const [previewDocLoader, setPreviewDocLoader] = useState(false);
  const [billDetailsModalData, setBillDetailsModalData] = useState([]);
  const [openBillDetailsModal, setOpenBillDetailsModal] = useState(false);
  const [billDetailsModalLoader, setBillDetailsModalLoader] = useState(false);
  // functions
  const handleCheckboxChange = (request_id, checked) => {
    setSelectedRequestIds((prev) =>
      checked ? [...prev, request_id] : prev.filter((id) => id !== request_id)
    );
  };

  const filteredData = allRefundData?.filter((row) =>
    Object.values(row).some((val) =>
      (val?.toString() || "").toLowerCase().includes(searchText.toLowerCase())
    )
  );

  const openPreviewDoc = () => {
    setPreviewDoc(true);
  };

  const closePreviewDoc = () => {
    setPreviewDoc(false);
  };

  // Function to open FileModal with correct file info
  const handleViewDocument = (fileUrl) => {
    if (!fileUrl) return;
    const extension = fileUrl.split(".").pop().toLowerCase();
    const type =
      extension === "pdf"
        ? "pdf"
        : extension === "png"
        ? "png"
        : extension === "jpeg"
        ? "jpeg"
        : "jpg";

    downloadOrPreviewFile(
      fileUrl,
      "preview",
      type === "jpeg" || type === "jpg"
        ? "image/jpeg"
        : type === "png"
        ? "image/png"
        : "application/pdf"
    );
  };
  // Now paginate the filtered data
  const paginatedRows = filteredData
    .slice((page - 1) * pageSize, page * pageSize)
    .map((row, index) => ({
      id: (page - 1) * pageSize + index + 1,
      ...row,
    }));
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleRowsPerPageChange = (e) => {
    setPageSize(Number(e.target.value));
    setPage(1); // reset to first page
  };

  const handleCloseApprovedModal = () => {
    setOpenApprovedModal(false);
  };

  const handleCloseBillDetailsModal = () => {
    setOpenBillDetailsModal(false);
  };
  //Api calls

  const approve_requestApi = async (request_type) => {
    const payload = {
      domain_id: domain_id,
      role: ssp_role === "21" ? "store" : ssp_role === "18" && "finance",
      request_ids: selectedRequestIds ?? [],
      approval_type: request_type,
    };
    setApproveRequestLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }approve_request`,
        true,
        false,
        payload
      );
      const response = data?.body;
      if (response?.status === "success") {
        toast.success(response?.message);
        getAllRefundDetailsApi();
        setSelectedRequestIds([]);
        setApproveRequestLoader(false);
      } else {
        setApproveRequestLoader(false);
        toast.error(response?.message, { autoClose: 1500 });
      }
    } catch (err) {
      setApproveRequestLoader(false);
      console.log(err);
    }
  };

  const handleOpenApprovedModal = async () => {
    const payload = {
      domain_id: domain_id,
      role: ssp_role === "21" ? "store" : ssp_role === "18" && "finance",
    };
    setapproveHistoryLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }approve_history`,
        true,
        false,
        payload
      );
      const response = data?.body;

      if (response?.status === "success") {
        setApprovedData(response?.data);
        setapproveHistoryLoader(false);
        setOpenApprovedModal(true);
      } else {
        setapproveHistoryLoader(false);
        setOpenApprovedModal(false);
        toast.error(response?.message, { autoClose: 1500 });
      }
    } catch (err) {
      setapproveHistoryLoader(false);
      setOpenApprovedModal(false);
      console.log(err);
    }
  };

  const handleDownload = async () => {
    try {
      const payload = {
        role: ssp_role === "21" ? "store" : ssp_role === "18" && "finance",
        domain_id: domain_id,
      };
      setDownloadingLoader(true);
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }download_history`,
        true,
        false,
        payload
      );
      const response = data?.body;

      if (
        response.status === "success" &&
        response.data &&
        response.data[0]?.url
      ) {
        const fileUrl = response.data[0].url;

        // Trigger the download
        const link = document.createElement("a");
        link.href = fileUrl;
        // link.download = "transaction_history.xlsx"; // Optional: Force a filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("File Download successfully");
        setDownloadingLoader(false);
      } else {
        toast.error("Failed to generate download link.");
        setDownloadingLoader(false);
      }
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Error occurred while downloading the file.");
      setDownloadingLoader(false);
    }
  };

  const downloadOrPreviewFile = async (
    fileName,
    type = "preview",
    mime_type = "image/png"
  ) => {
    try {
      setPreviewDocLoader(true);
      const payload = {
        domain_id: domain_id,
        file_name: fileName,
        type: type, // preview/download [download is default]
        mime_type: mime_type, //Any of the AWS supported Mime types
      };
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }download_s3_file`,
        true,
        false,
        payload
      );
      const response = data?.body;

      if (response.status === "success") {
        setpreviewDocData({ url: response?.data?.url, type: mime_type });
        setPreviewDocLoader(false);
        setPreviewDoc(true);
      } else {
        toast.error("Failed to generate preview / download link.");
        setPreviewDocLoader(false);
      }
    } catch (error) {
      console.error("Preview/Download Failed", error);
      toast.error("Error occurred while previewing / downloading the file.");
      setPreviewDocLoader(false);
    }
  };

  const handleYes = () => {
    if (approveModalOpen) {
      approve_requestApi("approve");
    } else if (rejectModalOpen) {
      approve_requestApi("reject");
    }
  };

  const handleNo = () => {
    if (approveModalOpen) {
      setApproveModalOpen(false);
    } else if (rejectModalOpen) {
      setRejectModalOpen(false);
    }
  };

  const viewBillDetails = async (bill_no) => {
    const payload = {
      // domain_id: domain_id,
      bill_no: bill_no,
    };
    setBillDetailsModalLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }get_submitted_bill_details`,
        true,
        false,
        payload
      );
      const response = data?.body;
      if (response?.status === "success") {
        setBillDetailsModalData(response?.data);
        setBillDetailsModalLoader(false);
        setOpenBillDetailsModal(true);
      } else {
        setBillDetailsModalLoader(false);
        setOpenBillDetailsModal(false);
        toast.error(response?.message, { autoClose: 1500 });
      }
    } catch (err) {
      setBillDetailsModalLoader(false);
      setOpenBillDetailsModal(false);
      console.log(err);
    }
  };
  // useEffects
  useEffect(() => {
    getAllRefundDetailsApi();
  }, []);

  const checkboxColumn = {
    field: "select",
    headerName: "",
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return (
        <Checkbox
          checked={selectedRequestIds.includes(params.row.request_id)}
          onChange={(e) =>
            handleCheckboxChange(params.row.request_id, e.target.checked)
          }
          sx={{
            color: "#fa4b16", // Tailwind orange-500
            "&.Mui-checked": {
              color: "#fa4b16", // orange-500
            },
          }}
        />
      );
    },
  };

  // Define the rest of the columns
  const baseColumns = [
    { field: "request_id", headerName: "Request ID", flex: 1.2 },
    {
      field: "bill_no",
      headerName: "Bill No.",
      flex: 1.2,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const billValue = params.value;
        return (
          <div className="viewDoc">
            <button type="button" onClick={() => viewBillDetails(billValue)}>
              {params.value}
            </button>
          </div>
        );
      },
    },
    {
      field: "refund_amount",
      headerName: "Payment Amount",
      flex: 1,
      valueFormatter: (params) => {
        // Protect against null or undefined
        if (params == null) return "";
        // Ensures it works for string or number types
        const value = Number(params);
        return isNaN(value) ? "" : value.toFixed(2);
      },
    },
    { field: "create_date", headerName: "Create Date", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
    { field: "utr_no", headerName: "UTR Number", flex: 1 },
    { field: "approved_date", headerName: "Payment Date", flex: 1 },
  ];

  // Filter baseColumns to exclude approved_date for finance role
  const filteredBaseColumns =
    ssp_role === "18"
      ? baseColumns.filter(
          (col) => col.field !== "approved_date" && col.field !== "utr_no"
        )
      : baseColumns;

  const financeColumns = [
    { field: "loc", headerName: "Store Code", flex: 0.8 },
    {
      field: "bank_name",
      headerName: "Bank Name",
      flex: 1,
    },
    { field: "bank_account_number", headerName: "Account No.", flex: 1 },
    { field: "bank_ifsc_code", headerName: "IFSC Code", flex: 1 },
    {
      field: "file_name",
      headerName: "View Document",
      flex: 0.8,
      sortable: false,
      filterable: false,

      renderCell: (params) => {
        const fileUrl = params.value;
        return (
          <div className="viewDoc">
            <button type="button" onClick={() => handleViewDocument(fileUrl)}>
              View
            </button>
          </div>
        );
      },
    },
  ];
  // Conditionally include the checkbox column at the beginning
  const columns =
    ssp_role === "18"
      ? [checkboxColumn, ...filteredBaseColumns, ...financeColumns]
      : baseColumns;

  useEffect(() => {
    const totalPages = Math.ceil(filteredData.length / pageSize);
    if (page > totalPages && totalPages > 0) {
      setPage(1); // reset to first valid page if current one is out of range
    }
  }, [filteredData, pageSize]);
  return (
    <>
      {/* Homepage Header  */}
      <div className="dsHomepageHeader">
        <div className="changeTextColor">Refund Requests</div>
        <div className="dsHomepageHeaderBtns">
          <button onClick={handleOpenCreateRequest} className="changeTextColor">
            {ssp_role === "18" ? "Bill Details" : "Create Request"}
          </button>
          <button onClick={handleDownload}>Download </button>
          {ssp_role === "18" && (
            <button onClick={handleOpenApprovedModal}>Approved Logs </button>
          )}
        </div>
      </div>

      {/* Table  */}

      <div className="custom-grid-container">
        <div className="customGridContainerSearch">
          <div>Search: </div>
          <input
            type="text"
            placeholder=""
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div className="data-grid-wrapper">
          {paginatedRows.length === 0 ? (
            <div className="no-data-message">
              <div>No data available</div>
            </div>
          ) : (
            <div className="data-grid-wrapper" style={{ height: "500px" }}>
              <DataGrid
                className="custom-data-grid"
                rows={paginatedRows}
                columns={columns}
                hideFooter
                disableRowSelectionOnClick
                rowHeight={42}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    overflowY: "auto", // ensure scroll happens here
                  },
                }}
              />
            </div>
          )}
        </div>

        {/* Custom Footer */}
        <div className="custom-footer">
          <div className="rows-per-page-container">
            <label htmlFor="rows-select">Enteries per page:</label>
            <select
              id="rows-select"
              className="rows-select"
              value={pageSize}
              onChange={handleRowsPerPageChange}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
            </select>
          </div>

          <div className="pagination-controls">
            <Pagination
              sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Fabriga", // or your custom font
                },
              }}
              count={Math.ceil(filteredData.length / pageSize)}
              page={page}
              onChange={handlePageChange}
              color="primary"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  slots={{
                    previous: () => <span>Previous</span>,
                    next: () => <span>Next</span>,
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>
      {ssp_role === "18" && (
        <div className="dsHomepageHeaderBtns financeApprove">
          <button
            disabled={selectedRequestIds?.length === 0}
            onClick={() => {
              setApproveModalOpen(true);
            }}>
            Approve
          </button>
          <button
            disabled={selectedRequestIds?.length === 0}
            onClick={() => {
              setRejectModalOpen(true);
            }}>
            Reject
          </button>
        </div>
      )}

      <DSApprovedModal
        open={openApprovedModal}
        close={handleCloseApprovedModal}
        data={approvedData}
      />
      <YesNoModal
        open={approveModalOpen || rejectModalOpen}
        onClose={handleNo}
        onYes={handleYes}
        onNo={handleNo}
        message={
          approveModalOpen
            ? "Are you sure you want to APPROVE"
            : rejectModalOpen && "Are you sure you want to REJECT"
        }
      />
      <FileModal
        open={previewDoc}
        onClose={closePreviewDoc}
        fileUrl={previewDocData.url}
        fileType={previewDocData.type}
      />
      <DSBillDetailsModal
        open={openBillDetailsModal}
        close={handleCloseBillDetailsModal}
        data={billDetailsModalData}
      />
      <Loader
        loading={
          allRefundDetailsLoader ||
          approveHistoryLoader ||
          downloadingLoader ||
          approveRequestLoader ||
          previewDocLoader ||
          billDetailsModalLoader
        }
        text={
          allRefundDetailsLoader
            ? "Fetching Pending Refund Bills"
            : approveHistoryLoader
            ? "Fetching Approved Bills"
            : downloadingLoader
            ? "Downloading File"
            : approveRequestLoader
            ? "Approving / Rejecting refund bill in progress"
            : previewDocLoader
            ? "Loading Preview"
            : billDetailsModalLoader
            ? "Fetching Bill Details"
            : ""
        }
      />
    </>
  );
};

export default DSRefundHomepage;
